<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.setGlobalData();
  },
  methods: {
    setGlobalData() {
      this.$store.setIsMobile();
      this.$store.setConfig();
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
@font-face {
  font-family: "pmzd";
  src: url("http://api.zyzxgc.cn/file/fonts/pangmenzhengdao.ttf")
    format("truetype");
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  text-decoration: none;
  color: inherit;
}
button {
  outline: none;
  border: none;

  &:active {
    transform: scale(0.9);
  }
}
// 隐藏number默认上下按钮
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-pagination button:disabled,
.el-pager li,
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background-color: transparent !important;
}

.swiper-initialized {
  --swiper-theme-color: #fff;
  --swiper-pagination-bullet-inactive-color: #fff;
  --swiper-pagination-bullet-inactive-opacity: 0.4;
}

.w1200 {
  width: 1200px;
  margin: 0 auto;
}

.el-pagination {
  text-align: center;
  margin: 10px 0;
}

.rich {
  word-break: break-all;

  img,
  video {
    max-width: 100%;
    height: auto;
  }
  p {
    margin: 1em 0;
  }
  table:not([cellpadding]) td,
  table:not([cellpadding]) th {
    padding: 0.4rem;
  }
  a:hover {
    text-decoration: underline;
  }
}

@media (max-width: 750px) {
  .w1200 {
    width: 100%;
  }
}
</style>
